exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-type-btn[data-v-89461610]{padding:3px;border:2px solid transparent;transition:.3s}.type-item[data-v-89461610]{padding:11px 16px;border:1px solid #afafaf}.is-selected[data-v-89461610]{border:4px solid var(--secondary)}", ""]);

// exports
